/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { UoMDimension, UomRestService } from '@gh/builder-shared-data';
import { DictionaryService, InitDialogViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { Observable } from 'rxjs';
import { UomDialogConfig } from '../components/uom-details/uom-details-dialog.component';
import { UOM_DETAILS_DEFAULT, UomDetails } from './uom-details.model';

@Injectable()
export class UomDetailsBusinessService implements InitDialogViewService<UomDialogConfig> {

  constructor(private uomRest: UomRestService,
              private dictionaryService: DictionaryService) {

  }

  initDialogView(route: DialogRouteSnapshot<UomDialogConfig>): any {
    return {
      dimensions: this.dictionaryService.getByEnum(UoMDimension),
      uomDetails: route.input.id ? this.get(<ID>route.input.id) : UOM_DETAILS_DEFAULT,
    };
  }

  get(id: ID): Observable<UomDetails> {
    return this.uomRest.get(id);
  }

  save(uomDetails: UomDetails): Observable<UomDetails> {
    if (uomDetails.id) {
      return this.update(uomDetails);
    }
    return this.create(uomDetails);
  }

  create(uomDetails: UomDetails): Observable<UomDetails> {
    return this.uomRest.create(uomDetails);
  }

  update(uomDetails: UomDetails): Observable<UomDetails> {
    return this.uomRest.update(uomDetails);
  }

}
